{
  "actions": {
    "title": "Nuovi prodotti",
    "devices": "Nuovi apparati",
    "applications": "Nuove applicazioni"
  },
  "services": {
    "title": "Attivazione dei servizi",
    "activeDirectory": "Active Directory",
    "pkiConnector": "Connettore PKI",
    "smtpServer": "Server SMTP",
    "unauthorized": "Nessuna informazione di attivazione del servizio disponibile"
  },
  "sector": {
    "title": "Le mie reti",
    "devices": "Apparati",
    "applications": "Applicazioni"
  },
  "certificates": {
    "valid": "Certificati validi",
    "certificate": "certificati",
    "device": "Certificati S4",
    "manager": "Certificati S4-Manager",
    "tools": "Certificati S4-Tools",
    "view": "Certificati S4-View",
    "legend": {
      "valid": "valido",
      "expireSoon": "validità < 1 mese",
      "expired": "scaduto"
    },
    "noData": "Nessun dato",
    "title": "Stato del certificato",
    "expired": "Scaduto",
    "lessThanOneMonth": "Meno di 1 mese",
    "lessThanThreeMonths": "Meno di 3 mesi",
    "lessThanSixMonths": "Meno di 6 mesi",
    "moreThanSixMonths": "Più di 6 mesi"
  },
  "firmwares": {
    "noData": "Al momento non sono disponibili dati sulla distribuzione delle versioni firmware",
    "others": "Altro",
    "title": "Distribuzione versione firmware",
    "unknown": "Sconosciuto"
  },
  "deviceStates": {
    "title": "Stato apparato",
    "states": {
      "activated": "Attivato",
      "disabled": "Disattivato",
      "preprovisioned": "Pre-provisioning effettuato",
      "registered": "Registrato",
      "locked": "Bloccato"
    }
  },
  "connectivity": {
    "title": "Stato di connettività",
    "states": {
      "lessThan": "Meno di {duration}",
      "moreThan": "Più di {duration}",
      "unknown": "Ancora nessuna interrogazione"
    },
    "noData": "Nessun dato"
  }
}
